import { put, takeEvery } from "redux-saga/effects";
import { createBrowserHistory } from "history";
import {
  FETCH_COUNTRY_INIT_ACTION,
  FETCH_COUNTRY_SUCCESS_ACTION,
  FETCH_COUNTRY_FAIL_ACTION,
  FETCH_CURRENCY_INIT_ACTION,
  FETCH_CURRENCY_SUCCESS_ACTION,
  FETCH_CURRENCY_FAIL_ACTION,
  FETCH_COUNTRYBYID_INIT_ACTION,
  FETCH_COUNTRYBYID_SUCCESS_ACTION,
  FETCH_COUNTRYBYID_FAIL_ACTION,
  ADD_CNTRY_CRNCY_INIT_ACTION,
  ADD_CNTRY_CRNCY_SUCCESS_ACTION,
  ADD_CNTRY_CRNCY__FAIL_ACTION,
  FETCH_CNTRY_CRNCY_INIT_ACTION,
  FETCH_CNTRY_CRNCY_SUCCESS_ACTION,
  FETCH_CNTRY_CRNCY__FAIL_ACTION,
  DELETE_CNTRY_CRNCY_INIT_ACTION,
  DELETE_CNTRY_CRNCY_SUCCESS_ACTION,
  DELETE_CNTRY_CRNCY_FAIL_CTION,
  EDIT_CNTRY_CRNCY_INIT_ACTION,
  EDIT_CNTRY_CRNCY_SUCCESS_ACTION,
  EDIT_CNTRY_CRNCY_FAIL_ACTION,
} from "./action";
import { push } from "connected-react-router";
import { appConfig } from "../../config";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

var btoa = require("Base64").btoa;
var history = createBrowserHistory();

function* fetchCountry() {
  try {
    const token = localStorage.getItem("token");
    const res = yield fetch(`${appConfig.ip}/country`, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });

    if (!res.ok) {
      let errJSON = {};
      try {
        errJSON = yield res.json();
      } catch {
        throw Object.assign(res, errJSON);
      }
    } else {
      const resJSON = yield res.json();

      yield put({
        type: FETCH_COUNTRY_SUCCESS_ACTION,
        payload: resJSON,
      });
    }
  } catch (err) {
    if (err.ok === false) {
      yield put({
        type: FETCH_COUNTRY_FAIL_ACTION,
        error: err,
      });
    }
  }
}

function* fetchCurrency() {
  try {
    const token = localStorage.getItem("token");
    const res = yield fetch(`${appConfig.ip}/currency`, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });

    if (!res.ok) {
      let errJSON = {};
      try {
        errJSON = yield res.json();
      } catch {
        throw Object.assign(res, errJSON);
      }
    } else {
      const resJSON = yield res.json();

      yield put({
        type: FETCH_CURRENCY_SUCCESS_ACTION,
        payload: resJSON,
      });
    }
  } catch (err) {
    if (err.ok === false) {
      yield put({
        type: FETCH_CURRENCY_FAIL_ACTION,
        error: err,
      });
    }
  }
}

function* fetchcountryById(value) {
  try {
    const token = localStorage.getItem("token");
    const res = yield fetch(
      `${appConfig.ip}/country?countryId=` + value.value,
      {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    );

    if (!res.ok) {
      let errJSON = {};
      try {
        errJSON = yield res.json();
      } catch {
        throw Object.assign(res, errJSON);
      }
    } else {
      const resJSON = yield res.json();

      yield put({
        type: FETCH_COUNTRYBYID_SUCCESS_ACTION,
        payload: resJSON,
      });
    }
  } catch (err) {
    if (err.ok === false) {
      yield put({
        type: FETCH_COUNTRYBYID_FAIL_ACTION,
        error: err,
      });
    }
  }
}

function* addCntryCrncy(value) {
  try {
    const token = localStorage.getItem("token");

    const data = {
      countryId: value.value.countryId,
      currencyId: value.value.currencyId,
    };

    const res = yield fetch(`${appConfig.ip}/countryCrncy`, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(data),
    });

    if (!res.ok) {
      const errJSON = yield res.json();
      yield toast.error(`failed to add country currency: ${errJSON.message}`, {
        autoClose: 3000,
      });
      throw Object.assign(res, errJSON);
    } else {
      const resJSON = yield res.json();

      yield put({ type: FETCH_CNTRY_CRNCY_INIT_ACTION });
      yield put({
        type: ADD_CNTRY_CRNCY_SUCCESS_ACTION,
        payload: resJSON,
      });
      yield toast.success("Country currency added successfully", {
        autoClose: 3000,
      });
    }
  } catch (err) {
    if (err.ok === false) {
      yield put({
        type: ADD_CNTRY_CRNCY__FAIL_ACTION,
        error: err,
      });
    }
  }
}

function* fetchCountryCrncy(value) {
  let pageno = value.value === undefined ? 1 : value.value;

  try {
    const token = localStorage.getItem("token");

    const res = yield fetch(
      `${appConfig.ip}/countryCrncy?limit=10&page=` + pageno,
      {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    );

    if (!res.ok) {
    } else {
      const resJSON = yield res.json();

      yield put({
        type: FETCH_CNTRY_CRNCY_SUCCESS_ACTION,
        payload: resJSON,
      });
    }
  } catch (err) {
    if (err.ok === false) {
      yield put({
        type: FETCH_CNTRY_CRNCY__FAIL_ACTION,
        error: err,
      });
    }
  }
}

function* deleteCrntyCrncy(value) {
  let id = value.value.id;

  const token = localStorage.getItem("token");
  try {
    const res = yield fetch(`${appConfig.ip}/countryCrncy/` + id, {
      method: "DELETE",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });
    if (!res.ok) {
      let errJSON = {};
      try {
        errJSON = yield res.json();
      } catch {}
      throw Object.assign(res, errJSON);
    } else {
      yield put({ type: FETCH_CNTRY_CRNCY_INIT_ACTION });
      yield toast.success("Deleted successfully", {
        autoClose: 3000,
      });
      const resJSON = yield res.json();

      yield put({
        type: DELETE_CNTRY_CRNCY_SUCCESS_ACTION,
      });
    }
  } catch (err) {
    if (err.ok === false) {
      yield put({ type: DELETE_CNTRY_CRNCY_FAIL_CTION, error: err });
    } else {
    }
  }
}

function* EditCntryCurency(value) {
  let id = value.value.id;
  let data = {
    countryId: value.value.countryId,
    currencyId: value.value.currencyId,

    // isActive: value.value.isActive,
  };

  const token = localStorage.getItem("token");
  try {
    const res = yield fetch(`${appConfig.ip}/countryCrncy/` + id, {
      method: "PUT",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(data),
    });
    if (!res.ok) {
      let errJSON = {};
      try {
        errJSON = yield res.json();
      } catch {}
      throw Object.assign(res, errJSON);
    } else {
      yield put({ type: FETCH_CNTRY_CRNCY_INIT_ACTION });
      yield toast.success("Country Currency updated successfully", {
        autoClose: 3000,
      });
      const resJSON = yield res.json();
      yield put({
        type: EDIT_CNTRY_CRNCY_SUCCESS_ACTION,
      });
    }
  } catch (err) {
    if (err.ok === false) {
      yield put({ type: EDIT_CNTRY_CRNCY_FAIL_ACTION, error: err });
    } else {
    }
  }
}

export function* CountryCrncyActionWatcher() {
  yield takeEvery(FETCH_COUNTRY_INIT_ACTION, fetchCountry);
  yield takeEvery(FETCH_CURRENCY_INIT_ACTION, fetchCurrency);
  yield takeEvery(FETCH_COUNTRYBYID_INIT_ACTION, fetchcountryById);
  yield takeEvery(ADD_CNTRY_CRNCY_INIT_ACTION, addCntryCrncy);
  yield takeEvery(FETCH_CNTRY_CRNCY_INIT_ACTION, fetchCountryCrncy);
  yield takeEvery(DELETE_CNTRY_CRNCY_INIT_ACTION, deleteCrntyCrncy);
  yield takeEvery(EDIT_CNTRY_CRNCY_INIT_ACTION, EditCntryCurency);
}
